import ChakraText from '~/common/componentMapper/Text';
import GenericTooltip from '~/common/components/GenericTooltip';

type TextProps = React.ComponentProps<typeof ChakraText> & {
  text?: string;
  helperText?: string;
};

export default function Text({
  text,
  sx,
  as = 'div',
  margin,
  helperText,
  padding,
  role,
  className,
}: Readonly<TextProps>) {
  // set as <div> since we can set text through markdown
  return (
    <ChakraText
      as={as}
      m={margin}
      p={padding}
      sx={sx}
      role={role}
      className={className}
    >
      {text}
      {!!helperText && <GenericTooltip label={helperText} />}
    </ChakraText>
  );
}
